import { gql } from '@apollo/client';

export const BRAND_BASIC_FRAGMENT = gql`
  fragment BrandBasic on Brand {
    id
    name
    image
    description
    isActive
    isRecommended
    metaDescription
    metaKeywords
    seoTitle
    sortOrder
    slug
  }
`;
